module.exports = __webpack_public_path__ + "static/media/defaultProfile.cd6d11ef.png";